// websocketSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../Store";
import { LocalChange } from "../../models/LocalChange";

export enum ConnectionState {
  notReadyForScenario = 0,
  readyForScenario = 1,
  playingScenario = 2,
}

interface WebSocketState {
  isConnected: boolean;
  connectionStatus: ConnectionState;
  localChanges: Record<string, LocalChange>;
}

const initialState: WebSocketState = {
  isConnected: false,
  connectionStatus: ConnectionState.notReadyForScenario,
  localChanges: {},
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    setConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    setConnectionStatus: (state, action: PayloadAction<ConnectionState>) => {
      state.connectionStatus = action.payload;
    },
    addLocalChange: (state, action: PayloadAction<LocalChange>) => {
      state.localChanges[action.payload.id] = action.payload;
    },
    removeLocalChange: (state, action: PayloadAction<string>) => {
      delete state.localChanges[action.payload];
    },
    clearLocalChanges: (state) => {
      state.localChanges = {};
    },
  },
});

export const {
  setConnected,
  setConnectionStatus,
  addLocalChange,
  removeLocalChange,
  clearLocalChanges,
} = websocketSlice.actions;

export const selectLocalChanges = (state: RootState) =>
  state.websocket.localChanges;

export const selectIsConnectedToWebSocket = (state: RootState) =>
  state.websocket.isConnected;

export const selectIsReadyForScenario = (state: RootState) =>
  state.websocket.connectionStatus === ConnectionState.readyForScenario;

export const selectConnectionStatus = (state: RootState) =>
  state.websocket.connectionStatus;

export default websocketSlice.reducer;
